import React from "react";

export const FormMandatoryIcon = () => {
  return (
    <span
      style={{
        color: "#ED1C24",
        fontWeight: "bolder",
      }}
    >
      {" "}
      *
    </span>
  );
};
